import { render, staticRenderFns } from "./SpotsList.vue?vue&type=template&id=f4c4b8ea&"
import script from "./SpotsList.vue?vue&type=script&lang=js&"
export * from "./SpotsList.vue?vue&type=script&lang=js&"
import style0 from "./SpotsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports